import React from 'react';
import { IconType } from 'react-icons';

import styled, { FlattenSimpleInterpolation } from 'styled-components';

import { Color } from '@assets/constants';
import { pressAnimation } from '@utils/animations';

interface Props {
  icon: IconType;
  size?: number;
  containerColor?: Color;
  iconColor?: Color;
  onClick?: () => void;
  animation?: FlattenSimpleInterpolation;
}

export const IconButton = ({
  icon,
  size,
  containerColor = Color.WHITE,
  iconColor,
  onClick,
  animation
}: Props) => {
  const iconElement = React.createElement(icon, {
    style: { color: iconColor }
  });

  return (
    <Container
      size={size}
      backgroundColor={containerColor}
      onClick={onClick}
      animation={animation}
    >
      {iconElement}
    </Container>
  );
};

const Container = styled.div<{
  size?: number;
  backgroundColor?: Color;
  animation?: FlattenSimpleInterpolation;
}>`
  cursor: pointer;
  margin-top: auto;
  margin-bottom: auto;
  width: ${(props) => props.size ?? 40}px;
  height: ${(props) => props.size ?? 40}px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 50%;
  background-color: ${(props) => props.backgroundColor ?? Color.WHITE};
  filter: drop-shadow(1px 2px 2px rgba(0, 0, 0, 0.1));
  svg {
    cursor: pointer;
    color: ${Color.GRAY};
  }
  ${pressAnimation}
  ${(props) => props.animation && props.animation}
`;
